/**
 * True when the OS signals a high-contrast preference — Windows High Contrast Mode
 * (`forced-colors: active`) or an explicit "increase / more contrast" setting (`prefers-contrast: more`).
 * Used to default to the accessible theme when the user has no saved preference.
 */
export const prefersHighContrast = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return (
    window.matchMedia('(forced-colors: active)').matches ||
    window.matchMedia('(prefers-contrast: more)').matches
  );
};
